import { Component } from "@angular/core";

@Component({
    selector: "smartfleet-empty-route",
    template: "",
    standalone: false
})
export class EmptyRouteComponent {}
